<template>
  <div>
	Time ON
  <div class="blob">
    Start
  </div>
  {{message}}
  <div class="btn" @click.prevent="startTimer()">Retry</div>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import moment from 'moment';
import axios from 'axios'
const http = axios.create({
  withCredentials: true,
  crossdomain: true
})
export default {
  name: 'TapOn',
  props: {
  },
  data () {
    return {
      message:'PAGE ERROR'
    }
  },
  methods: {
    startTimer:function(){
      localStorage.setItem('timer-started', moment().format('X'));
      this.message = 'The Timer has started';
      var self = this;
      setTimeout(function () {
        
        self.$router.push('taprunning') 
      }, 1000);
    }
  },
  mounted() {
    this.pageref = this.$route.path;
    if (!localStorage.getItem('timer-started'))
      this.startTimer();
    else {
      this.message = 'No ROUTE';
      this.$router.push('tapoff')
    }

  },
  created: function () {
  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
</style>







